webpackJsonp([258],{

/***/ 1219:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTaskPackageTable_vue__ = __webpack_require__(2932);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45bfde17_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTaskPackageTable_vue__ = __webpack_require__(5239);
function injectStyle (ssrContext) {
  __webpack_require__(5235)
  __webpack_require__(5237)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45bfde17"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectTaskPackageTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45bfde17_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectTaskPackageTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return opts; });
/* unused harmony export getOptionLabel */
/* harmony export (immutable) */ __webpack_exports__["c"] = getDisplayStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDisplayFormLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getDisplayStatusTagType;
/* harmony export (immutable) */ __webpack_exports__["e"] = isDisplayEnabled;
/* harmony export (immutable) */ __webpack_exports__["f"] = isDisplayPartial;
var consts = {
  /** 全部展示 */
  DISPLAY_ALL: 1,
  /** 部分展示 */
  DISPLAY_PARTIAL: 2,
  /** 不展示 */
  DISPLAY_NONE: 3
};

var opts = {
  /** 列表展示状态（短文案） */
  displayStatusMaps: [{ value: consts.DISPLAY_ALL, label: '全部展示' }, { value: consts.DISPLAY_PARTIAL, label: '部分展示' }, { value: consts.DISPLAY_NONE, label: '不展示' }],
  /** 表单单选（完整文案） */
  displayFormMaps: [{ value: consts.DISPLAY_ALL, label: '展示，所有用户可见' }, { value: consts.DISPLAY_PARTIAL, label: '展示，部分用户可见' }, { value: consts.DISPLAY_NONE, label: '不展示任务包' }]
};

function getOptionLabel(options, value) {
  var item = (options || []).find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getDisplayStatusLabel(display) {
  return getOptionLabel(opts.displayStatusMaps, display) || '不展示';
}

function getDisplayFormLabel(display) {
  return getOptionLabel(opts.displayFormMaps, display) || '不展示任务包';
}

function getDisplayStatusTagType(display) {
  switch (Number(display)) {
    case consts.DISPLAY_ALL:
      return 'success';
    case consts.DISPLAY_PARTIAL:
      return 'warning';
    case consts.DISPLAY_NONE:
      return 'info';
    default:
      return 'info';
  }
}

function isDisplayEnabled(display) {
  var value = Number(display);
  return value === consts.DISPLAY_ALL || value === consts.DISPLAY_PARTIAL;
}

function isDisplayPartial(display) {
  return Number(display) === consts.DISPLAY_PARTIAL;
}

/***/ }),

/***/ 2932:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__project_task_package_constants__ = __webpack_require__(1821);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__core_mixins_table__["b" /* default */]],
  data: function data() {
    return {
      searchExpanded: true,
      listExpanded: true,
      search: {
        projectid: null,
        search_status: null,
        package_title: null
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      searchFieldType: {
        projectid: Number,
        search_status: Number,
        package_title: String
      },
      getDisplayStatusLabel: __WEBPACK_IMPORTED_MODULE_3__project_task_package_constants__["c" /* getDisplayStatusLabel */],
      getDisplayStatusTagType: __WEBPACK_IMPORTED_MODULE_3__project_task_package_constants__["d" /* getDisplayStatusTagType */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    projectStatusOptions: function projectStatusOptions(state) {
      return state.customerProjectcost.options.project_status;
    },
    statusOptions: function statusOptions(state) {
      return state.customerProjectcost.options.status;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, request.map(['getProjectTable', 'getProjectDetail']), {
    /**
     * 兼容旧 URL：?status=20&status=50... → search_status
     */
    setSearchParams: function setSearchParams(params) {
      if (params.search_status == null && params.status != null) {
        var matched = this.findProjectStatusOption(params.status);
        if (matched) {
          params.search_status = matched.key;
        }
      }
      for (var key in this.search) {
        if (this.search.hasOwnProperty(key) && params.hasOwnProperty(key)) {
          this.search[key] = params[key];
        }
      }
    },
    findProjectStatusOption: function findProjectStatusOption(status) {
      var values = [].concat(status).map(Number);
      return (this.projectStatusOptions || []).find(function (item) {
        var optionValues = (item.value || []).map(Number);
        if (optionValues.length !== values.length) {
          return false;
        }
        return optionValues.every(function (v) {
          return values.indexOf(v) !== -1;
        }) && values.every(function (v) {
          return optionValues.indexOf(v) !== -1;
        });
      });
    },
    resolveStatusFilter: function resolveStatusFilter(searchStatus) {
      if (searchStatus == null || searchStatus === '') {
        return null;
      }
      var item = (this.projectStatusOptions || []).find(function (it) {
        return Number(it.key) === Number(searchStatus);
      });
      return item ? item.value : null;
    },
    getTableData: function getTableData(params) {
      var requestParams = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, params);
      var status = this.resolveStatusFilter(requestParams.search_status);
      delete requestParams.search_status;
      if (status) {
        requestParams.status = status;
      }
      return request.page('queryProjectTaskPackageProjects', requestParams);
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      this.onSearch();
    },
    formatStatus: function formatStatus(status) {
      var item = (this.statusOptions || []).find(function (it) {
        return Number(it.value) === Number(status);
      });
      return item ? item.label : status;
    },
    projectStatusTagType: function projectStatusTagType(status) {
      var value = Number(status);
      // 开立
      if (value === 1) {
        return 'info';
      }
      // 审核中
      if ([20, 50, 60, 70].indexOf(value) !== -1) {
        return 'warning';
      }
      // 完成
      if (value === 30) {
        return 'success';
      }
      // 关闭
      if (value === 40) {
        return 'info';
      }
      // 已驳回
      if (value === 80) {
        return 'danger';
      }
      return '';
    },
    goConfig: function goConfig(row) {
      this.$router.push({ name: '任务包配置', params: { projectId: row.id } });
    },
    goTraining: function goTraining(row) {
      this.$router.push({
        path: '/batch/table/' + row.id,
        query: { mode: 'training_only', projectname: row.name || '' }
      });
    }
  })
});

/***/ }),

/***/ 5235:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5236);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("5c3e422e", content, true, {});

/***/ }),

/***/ 5236:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".project-task-package-table__card[data-v-45bfde17]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,.08);box-shadow:0 1px 3px rgba(0,0,0,.08);overflow:hidden}.project-task-package-table__card+.project-task-package-table__card[data-v-45bfde17]{margin-top:16px}.project-task-package-table__card-header[data-v-45bfde17]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500}.project-task-package-table__card-header i[data-v-45bfde17]{color:#909399}.project-task-package-table__card-header-actions[data-v-45bfde17]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.project-task-package-table__card-header-actions ::v-deep .project-task-package-table__header-action.el-button[data-v-45bfde17]{min-width:24px;padding:0;margin:0}.project-task-package-table__header-action[data-v-45bfde17]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1}.project-task-package-table__header-action i[data-v-45bfde17]{font-size:14px}.project-task-package-table__search-form[data-v-45bfde17]{padding:16px 24px 20px}.project-task-package-table__search-grid[data-v-45bfde17]{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px 16px}.project-task-package-table__search-actions[data-v-45bfde17]{margin-top:16px;padding-top:4px}.project-task-package-table__list-body[data-v-45bfde17]{padding:16px}.project-task-package-table__table-wrap[data-v-45bfde17]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden;margin-top:0}.project-task-package-table__table-wrap ::v-deep .el-table[data-v-45bfde17]:after,.project-task-package-table__table-wrap ::v-deep .el-table[data-v-45bfde17]:before{display:none}.project-task-package-table__table-wrap ::v-deep .el-table__body tr:last-child td[data-v-45bfde17]{border-bottom:none}.project-task-package-table__table ::v-deep th[data-v-45bfde17]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500}.project-task-package-table__table ::v-deep td[data-v-45bfde17]{font-size:14px;color:#303133}.project-task-package-table__table ::v-deep .el-table__row:hover>td[data-v-45bfde17]{background:#fafafa}.project-task-package-table__tag[data-v-45bfde17]{margin:0 4px 4px 0}.project-task-package-table__actions[data-v-45bfde17]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;padding:4px 0}.project-task-package-table__action[data-v-45bfde17]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;background:#fff;cursor:pointer;-webkit-transition:background-color .15s ease;transition:background-color .15s ease;outline:none;font-family:inherit}.project-task-package-table__action.is-edit[data-v-45bfde17]{color:#606266;border:1px solid #909399}.project-task-package-table__action.is-bind[data-v-45bfde17]{color:#2563eb;border:1px solid #3b82f6}.project-task-package-table__action[data-v-45bfde17]:hover{background:#f9fafb}.project-task-package-table .pagination[data-v-45bfde17]{margin:16px auto 0;text-align:center}@media (max-width:1200px){.project-task-package-table__search-grid[data-v-45bfde17]{grid-template-columns:repeat(2,minmax(0,1fr))}}@media (max-width:768px){.project-task-package-table__search-grid[data-v-45bfde17]{grid-template-columns:1fr}}", "", {"version":3,"sources":["/workspace/src/views/project-task-package/pages/ProjectTaskPackageTable.vue"],"names":[],"mappings":"AACA,mDAAmD,gBAAgB,kBAAkB,6CAA8C,qCAAsC,eAAe,CACvL,AACD,qFAAqF,eAAe,CACnG,AACD,0DAA0D,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,yBAAyB,sBAAsB,8BAA8B,kBAAkB,gCAAgC,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,cAAc,eAAe,eAAe,CAC/b,AACD,4DAA4D,aAAa,CACxE,AACD,kEAAkE,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,OAAO,CAC/L,AACD,gIAAgI,eAAe,UAAU,QAAQ,CAChK,AACD,4DAA4D,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,UAAU,SAAS,cAAc,oBAAoB,cAAc,aAAa,CAClX,AACD,8DAA8D,cAAc,CAC3E,AACD,0DAA0D,sBAAsB,CAC/E,AACD,0DAA0D,aAAa,8CAAgD,aAAa,CACnI,AACD,6DAA6D,gBAAgB,eAAe,CAC3F,AACD,wDAAwD,YAAY,CACnE,AACD,yDAAyD,yBAAyB,kBAAkB,gBAAgB,YAAY,CAC/H,AACD,qKAAuK,YAAY,CAClL,AACD,mGAAmG,kBAAkB,CACpH,AACD,gEAAgE,mBAAmB,cAAc,eAAe,eAAe,CAC9H,AACD,gEAAgE,eAAe,aAAa,CAC3F,AACD,qFAAqF,kBAAkB,CACtG,AACD,kDAAkD,kBAAkB,CACnE,AACD,sDAAsD,oBAAoB,oBAAoB,aAAa,mBAAmB,eAAe,QAAQ,aAAa,CACjK,AACD,qDAAqD,qBAAqB,iBAAiB,kBAAkB,eAAe,iBAAiB,gBAAgB,gBAAgB,eAAe,8CAA+C,sCAAuC,aAAa,mBAAmB,CACjT,AACD,6DAA6D,cAAc,wBAAwB,CAClG,AACD,6DAA6D,cAAc,wBAAwB,CAClG,AACD,2DAA2D,kBAAkB,CAC5E,AACD,yDAAyD,mBAAmB,iBAAiB,CAC5F,AACD,0BACA,0DAA0D,6CAA+C,CACxG,CACA,AACD,yBACA,0DAA0D,yBAAyB,CAClF,CACA","file":"ProjectTaskPackageTable.vue","sourcesContent":["\n.project-task-package-table__card[data-v-45bfde17]{background:#fff;border-radius:8px;-webkit-box-shadow:0 1px 3px rgba(0,0,0,0.08);box-shadow:0 1px 3px rgba(0,0,0,0.08);overflow:hidden\n}\n.project-task-package-table__card+.project-task-package-table__card[data-v-45bfde17]{margin-top:16px\n}\n.project-task-package-table__card-header[data-v-45bfde17]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:12px 24px;border-bottom:1px solid #ebeef5;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;color:#606266;font-size:14px;font-weight:500\n}\n.project-task-package-table__card-header i[data-v-45bfde17]{color:#909399\n}\n.project-task-package-table__card-header-actions[data-v-45bfde17]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px\n}\n.project-task-package-table__card-header-actions ::v-deep .project-task-package-table__header-action.el-button[data-v-45bfde17]{min-width:24px;padding:0;margin:0\n}\n.project-task-package-table__header-action[data-v-45bfde17]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:24px;height:24px;padding:0;margin:0;color:#909399;-ms-flex-negative:0;flex-shrink:0;line-height:1\n}\n.project-task-package-table__header-action i[data-v-45bfde17]{font-size:14px\n}\n.project-task-package-table__search-form[data-v-45bfde17]{padding:16px 24px 20px\n}\n.project-task-package-table__search-grid[data-v-45bfde17]{display:grid;grid-template-columns:repeat(3, minmax(0, 1fr));gap:12px 16px\n}\n.project-task-package-table__search-actions[data-v-45bfde17]{margin-top:16px;padding-top:4px\n}\n.project-task-package-table__list-body[data-v-45bfde17]{padding:16px\n}\n.project-task-package-table__table-wrap[data-v-45bfde17]{border:1px solid #ebeef5;border-radius:8px;overflow:hidden;margin-top:0\n}\n.project-task-package-table__table-wrap ::v-deep .el-table[data-v-45bfde17]::before,.project-task-package-table__table-wrap ::v-deep .el-table[data-v-45bfde17]::after{display:none\n}\n.project-task-package-table__table-wrap ::v-deep .el-table__body tr:last-child td[data-v-45bfde17]{border-bottom:none\n}\n.project-task-package-table__table ::v-deep th[data-v-45bfde17]{background:#f5f7fa;color:#909399;font-size:12px;font-weight:500\n}\n.project-task-package-table__table ::v-deep td[data-v-45bfde17]{font-size:14px;color:#303133\n}\n.project-task-package-table__table ::v-deep .el-table__row:hover>td[data-v-45bfde17]{background:#fafafa\n}\n.project-task-package-table__tag[data-v-45bfde17]{margin:0 4px 4px 0\n}\n.project-task-package-table__actions[data-v-45bfde17]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:6px;padding:4px 0\n}\n.project-task-package-table__action[data-v-45bfde17]{display:inline-block;padding:4px 10px;border-radius:4px;font-size:12px;line-height:18px;font-weight:500;background:#fff;cursor:pointer;-webkit-transition:background-color 0.15s ease;transition:background-color 0.15s ease;outline:none;font-family:inherit\n}\n.project-task-package-table__action.is-edit[data-v-45bfde17]{color:#606266;border:1px solid #909399\n}\n.project-task-package-table__action.is-bind[data-v-45bfde17]{color:#2563eb;border:1px solid #3b82f6\n}\n.project-task-package-table__action[data-v-45bfde17]:hover{background:#f9fafb\n}\n.project-task-package-table .pagination[data-v-45bfde17]{margin:16px auto 0;text-align:center\n}\n@media (max-width: 1200px){\n.project-task-package-table__search-grid[data-v-45bfde17]{grid-template-columns:repeat(2, minmax(0, 1fr))\n}\n}\n@media (max-width: 768px){\n.project-task-package-table__search-grid[data-v-45bfde17]{grid-template-columns:1fr\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5237:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5238);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("8ce52622", content, true, {});

/***/ }),

/***/ 5238:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".project-task-package-table__search-form .el-form-item{margin-bottom:0}.project-task-package-table__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px}", "", {"version":3,"sources":["/workspace/src/views/project-task-package/pages/ProjectTaskPackageTable.vue"],"names":[],"mappings":"AACA,uDAAuD,eAAe,CACrE,AACD,8DAA8D,cAAc,eAAe,gBAAgB,CAC1G","file":"ProjectTaskPackageTable.vue","sourcesContent":["\n.project-task-package-table__search-form .el-form-item{margin-bottom:0\n}\n.project-task-package-table__search-form .el-form-item__label{color:#606266;font-size:13px;line-height:32px\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5239:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],staticClass:"project-task-package-table"},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("平台管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("任务包及培训配置")])],1)],1),_vm._v(" "),_c('div',{staticClass:"project-task-package-table__card project-task-package-table__card--search"},[_c('div',{staticClass:"project-task-package-table__card-header",on:{"click":function($event){_vm.searchExpanded = !_vm.searchExpanded}}},[_c('span',[_vm._v("搜索")]),_vm._v(" "),_c('i',{class:_vm.searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})]),_vm._v(" "),_c('el-form',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchExpanded),expression:"searchExpanded"}],ref:"searchForm",staticClass:"project-task-package-table__search-form",attrs:{"model":_vm.search,"label-width":"96px","label-position":"left","size":"small"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"project-task-package-table__search-grid"},[_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"id","label-key":"name","value-key":"id","placeholder":"请输入项目名称搜索","query-request":_vm.getProjectTable,"find-request":_vm.getProjectDetail,"query-params":{no_ajx: 1}},model:{value:(_vm.search.projectid),callback:function ($$v) {_vm.$set(_vm.search, "projectid", $$v)},expression:"search.projectid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目状态","prop":"search_status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择"},model:{value:(_vm.search.search_status),callback:function ($$v) {_vm.$set(_vm.search, "search_status", $$v)},expression:"search.search_status"}},_vm._l((_vm.projectStatusOptions),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.key}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"任务包名称","prop":"package_title"}},[_c('el-input',{attrs:{"placeholder":"请输入任务包名称","clearable":""},model:{value:(_vm.search.package_title),callback:function ($$v) {_vm.$set(_vm.search, "package_title", $$v)},expression:"search.package_title"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"project-task-package-table__search-actions"},[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{attrs:{"icon":"el-icon-refresh"},on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"project-task-package-table__card"},[_c('div',{staticClass:"project-task-package-table__card-header",on:{"click":function($event){_vm.listExpanded = !_vm.listExpanded}}},[_c('span',[_vm._v("列表")]),_vm._v(" "),_c('div',{staticClass:"project-task-package-table__card-header-actions"},[_c('el-button',{staticClass:"project-task-package-table__header-action",attrs:{"type":"text","icon":"el-icon-refresh"},on:{"click":function($event){$event.stopPropagation();return _vm.onRefresh()}}}),_vm._v(" "),_c('span',{staticClass:"project-task-package-table__header-action"},[_c('i',{class:_vm.listExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'})])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.listExpanded),expression:"listExpanded"}],staticClass:"project-task-package-table__list-body"},[_c('div',{staticClass:"project-task-package-table__table-wrap"},[_c('el-table',{staticClass:"project-task-package-table__table",staticStyle:{"width":"100%"},attrs:{"data":_vm.table}},[_c('el-table-column',{attrs:{"prop":"id","label":"项目ID","width":"88"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"number","label":"项目编码","min-width":"120","show-overflow-tooltip":""}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"项目名称","min-width":"160","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-link',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.goConfig(scope.row)}}},[_vm._v(_vm._s(scope.row.name || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"项目状态","width":"100","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"size":"mini","type":_vm.projectStatusTagType(scope.row.status)}},[_vm._v("\n                "+_vm._s(_vm.formatStatus(scope.row.status))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"所属客户","min-width":"160","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.customer_name)+"/"+_vm._s(scope.row.customerid)+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pending_task_count","label":"待抢单门店任务数","width":"140","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"app_task_package_display","label":"展示状态","width":"110","align":"center"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tag',{attrs:{"size":"mini","type":_vm.getDisplayStatusTagType(scope.row.app_task_package_display)}},[_vm._v("\n                "+_vm._s(_vm.getDisplayStatusLabel(scope.row.app_task_package_display))+"\n              ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"package_title","label":"首页任务包名称","min-width":"140","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n              "+_vm._s(scope.row.package_title || '-')+"\n            ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"标签","min-width":"180"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.flag_names && scope.row.flag_names.length)?_vm._l((scope.row.flag_names),function(name,idx){return _c('el-tag',{key:idx,staticClass:"project-task-package-table__tag",attrs:{"size":"mini"}},[_vm._v(_vm._s(name))])}):_c('span',[_vm._v("-")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"updated_at","label":"更新时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"200","align":"left"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"project-task-package-table__actions"},[_c('span',{staticClass:"project-task-package-table__action is-edit",on:{"click":function($event){return _vm.goConfig(scope.row)}}},[_vm._v("任务包配置")]),_vm._v(" "),_c('span',{staticClass:"project-task-package-table__action is-bind",on:{"click":function($event){return _vm.goTraining(scope.row)}}},[_vm._v("培训配置")])])]}}])})],1)],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/ProjectTaskPackageTable.3fb7dd835b71c2b7983d.js